import animixin from "~/mixins/animations.js"
import Vue from "vue"

export default {
  mixins: [animixin],
  mounted: function () {},
  data: function () {
    return {
      hover: false,
      cmpHover: false,
      focus: false,
      cmpFocus: false,
    }
  },
  computed: {
    cmpClass: function () {
      var ret = {}

      ret[this.visual] = true
      ret.disabled = this.disabled || this.loading
      ret.loading = this.loading
      ret.hover = this.cmpHover
      ret.focus = this.cmpFocus
      ret.enabled = this.enabled
      return ret
    },
  },
  methods: {
    emitClick: function () {
      if (!this.disabled) this.$emit("click")
    },
    chooseAnistate: function () {
      if (this.cmpHover && this.hover) {
        this.aniSpeed = 0.15
        this.changeAniSate("standart")
        if (!this.focus && this.cmpFocus) this.changeAniSate("decelerate")
      }
      if (this.cmpHover && !this.hover) {
        this.aniSpeed = 0.1
        this.changeAniSate("decelerate")
      }
      Vue.nextTick(() => {
        this.updateCmps()
      })
    },
    updateCmps: function () {
      this.cmpHover = this.hover
      this.cmpFocus = this.focus
    },
  },
  watch: {
    hover: function () {
      this.chooseAnistate()
    },
    focus: function () {
      this.chooseAnistate()
    },
    cmpHover: function () {
      this.chooseAnistate()
    },
  },
  props: {
    text: [String, Number],
    visual: {
      type: String,
      default: function () {
        return "main"
      },
      validator: function (value) {
        const available = [
          "small",
          "cutemain",
          "keromain",
          "hachimain",
          "main",
          "bigroundmain",
          "bigmain",
          "hollowmain",
          "bighollowmain",
          "hugemain",
          "param",
          "smallparam",
          "hollowparam",
          "bighollowparam",
          "hugeparam",
          "facebook",
          "grey",
        ]

        return available.indexOf(value) !== -1
      },
    },
    enabled: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    disabled: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    loading: {
      type: Boolean,
      default: function () {
        return false
      },
    },
  },
}
